import React, { useEffect, useRef } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { CircularProgress } from '@deere/fuel-react';
import { isLoggingOut } from './logoutState';

export const SecureRoute = ({ children }) => {
    const { oktaAuth, authState } = useOktaAuth();
    // Guards against concurrent signInWithRedirect calls racing the PKCE
    // codeVerifier write against window.location navigation.
    const redirectStartedRef = useRef(false);

    useEffect(() => {
        if (!authState) {
            return;
        }
        if (authState.isAuthenticated) {
            redirectStartedRef.current = false;
            return;
        }
        if (redirectStartedRef.current) {
            return;
        }
        // A logout clears the tokens (flipping authState to unauthenticated)
        // and then redirects to the SSO signout URL. Skip re-authenticating
        // here so we don't race that redirect and silently log the user back
        // in via the still-alive master SSO session.
        if (isLoggingOut()) {
            return;
        }
        redirectStartedRef.current = true;
        const originalUri = toRelativeUrl(
            window.location.href,
            window.location.origin
        );
        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();
    }, [oktaAuth, authState]);

    if (!authState || !authState?.isAuthenticated) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size="lg" variant="indeterminate" />
            </div>
        );
    }
    return <>{children}</>;
};
